import Constants from 'expo-constants';

export class StringTable
{
public static APP_NAME             = 'Rithmic Trader';
public static APP_NAME_PRO         = 'Rithmic Trader Pro';
public static APP_VERSION          = '2.5.0.0';
public static DEBUG                = false;

// public static APP_VERSION          = Constants.expoConfig?.extra?.expo_version + '.0'; //'2.4.0.0';
//public static EXPO_VERSION         = '2.4.0'; //3 parts only
// public static APP_VERSION          = StringTable.EXPO_VERSION + '.0-ww' + Constants.expoConfig?.extra?.fact3; //display version
// public static IOS_BUILD            = "13";
//public static ANDROID_VER_CODE     = 93;
// public static DEBUG                = Constants.expoConfig?.extra?.debug_putput === 'true';

// public static URL                  = 'wss://rprotocol-beta.rithmic.com:443';
//public static URL                  = 'wss://rprotocol.rithmic.com:443';
//public static URL                  = 'ws://rittz00100.rithmic.com:40056';
// public static SYSTEM               = "Rithmic Paper Trading";
//public static SYSTEM               = "Rithmic Dev";

public static TEMPLATE_VER         = "2.0";
public static RECONNECT            = 'reconnect';

// public static FONT_NORMAL           = 'Caveat_700Bold';
// public static FONT_BOLD             = 'Caveat_700Bold';
// public static FONT_BLACK            = 'Caveat_700Bold';

public static S_PENDING            = "open";
public static S_COMPLETE           = "complete";
public static S_MODIFIED           = "modified";
public static S_REL_PENDING        = "release pending";
public static S_STP_PENDING        = "trigger pending";
public static S_MODTRIGGERPENDING  = "modified, trigger pending";
public static S_MODRELPENDING      = "modified, release pending";
public static S_PARTIAL_FILL       = "partial";

}

/*   ====================================================================   */
